import React from 'react';
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { PiLinkBold } from 'react-icons/pi';
import FormatNumber from '../../../components/FormatNumber';
import NoAvailable from '../../../components/NoAvailable';
import { PaymentLinkView } from '../models/payment-link-view';
import { PaymentLinkViewStatusBadge } from './PaymentLinkViewStatusBadge';
import { CopyLinkButton } from './CopyLinkButton';

interface RecentPaymentLinksProps {
  links: PaymentLinkView[];
  loading: boolean;
  error: string | null;
}

export const RecentPaymentLinks = ({ links, loading, error }: RecentPaymentLinksProps) => {
  const navigate = useNavigate();

  return (
    <Box backgroundColor="white" borderRadius="16px" padding="xxl">
      <Flex justifyContent="space-between" alignItems="center" flexWrap="wrap" gap="l" marginBottom="xl">
        <Heading as="h3" fontSize="xl">Últimos Links Generados</Heading>
        <Button
          leftIcon={<PiLinkBold />}
          colorScheme="button-primary"
          borderRadius="full"
          size="sm"
          onClick={() => navigate('../consulta')}
        >
          Ver Todos los Links Generados
        </Button>
      </Flex>

      {loading &&
        <Center paddingY="xxl" color="neutral.600"><Spinner /></Center>
      }

      {!loading && !!error &&
        <Center paddingY="xxl" color="destructive.700">{error}</Center>
      }

      {!loading && !error && links.length === 0 &&
        <NoAvailable />
      }

      {!loading && !error && links.length > 0 &&
        <TableContainer overflowX="auto">
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Concepto</Th>
                <Th>Monto</Th>
                <Th>Estado</Th>
                <Th>Link</Th>
              </Tr>
            </Thead>
            <Tbody>
              {links.map((link) => (
                <Tr key={link.id}>
                  <Td fontSize="s">{link.concept}</Td>
                  <Td fontSize="s">
                    <FormatNumber value={link.amount} style="currency" currency={link.currencyCode || 'MXN'} locale="es-MX" />
                  </Td>
                  <Td fontSize="s"><PaymentLinkViewStatusBadge status={link.status} /></Td>
                  <Td fontSize="s">{link.url ? <CopyLinkButton url={link.url} /> : '—'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      }
    </Box>
  );
};
